// 🔧 result_strategy_helpers.js
// ✅ Purpose: Shared result strategy helpers for all voting engines
// ✅ Features:
// - Centralizes result strategy checks
// - Supports vote counting, ranked elimination, average score, and scorecard average strategies
// - Helps audit.js, ballot.js, leaderboard.js, leaderboard_print.js avoid hard-coded voting type checks
// - Works with voting_engine_registry.js
// - Fully block-commented for clarity and future devs

import {
  getResultStrategy,
  isJudgedVotingFamily,
  isSelectionVotingFamily,
} from "./voting_engine_registry";

export function isVoteCountStrategy(votingType = "standard") {
  return getResultStrategy(votingType) === "count_votes";
}

export function isRankedEliminationStrategy(votingType = "standard") {
  return getResultStrategy(votingType) === "ranked_elimination";
}

export function isAverageScoreStrategy(votingType = "standard") {
  return getResultStrategy(votingType) === "average_score";
}

export function isAverageScorecardStrategy(votingType = "standard") {
  return getResultStrategy(votingType) === "average_scorecard";
}

export function supportsJudgedResults(votingType = "standard") {
  return (
    isJudgedVotingFamily(votingType) &&
    (
      isAverageScoreStrategy(votingType) ||
      isAverageScorecardStrategy(votingType)
    )
  );
}

export function supportsSelectionResults(votingType = "standard") {
  return (
    isSelectionVotingFamily(votingType) &&
    (
      isVoteCountStrategy(votingType) ||
      isRankedEliminationStrategy(votingType)
    )
  );
}